<template>
  <div class="movie-page">
    <Header />
    <div class="page-header">
      <img v-if="isPC" class="page-header-text" src="@/assets/images/movie/pc_img_movie_02.png">
      <img v-else class="page-header-text" src="@/assets/images/movie/sp_img_movie_02.png">
    </div>
    <section class="heading-tag">
      <div class="heading-tag-body">
        <div class="heading-tag-head"><img src="@/assets/images/header/pc_icon_header.png">MOVIE LIST</div>
      </div>
    </section>
    <div class="movie-wrap">
      <div class="movie-block" style="margin-bottom: 20px;">
        <div class="movie-block-text">【豪華YouTube特番】『リアルイベント体験会』</div>
        <iframe class="movie-block-iframe" src="https://www.youtube.com/embed/pb1Qulk3OdM?si=UX4dsjEBX_kkFc2m" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      <div class="movie-block" style="margin-bottom: 20px;">
        <div class="movie-block-text">【新OPムービー公開】スマホゲーム『ひなこい』9月15日（月）リニューアル！</div>
        <iframe class="movie-block-iframe" src="https://www.youtube.com/embed/NReXx1hUdFI?si=WKg7RSUovks75vLR" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      <div class="movie-block" style="margin-bottom: 20px;">
        <div class="movie-block-text">【五期生入学PV公開】9/26（金）スマホゲーム『ひなこい』に日向坂46 五期生入学！</div>
        <iframe class="movie-block-iframe" src="https://www.youtube.com/embed/GKhEm0bPS2w?si=lN-WGbgxwP1gX3of" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import resolution from '@/mixin/resolution';

export default {
  name: 'MoviePage',
  components: { Footer, Header },
  mixins: [resolution]
}
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  background-image: url('@/assets/images/movie/pc_img_movie_01.png');
  background-size: contain;
  background-repeat: no-repeat;
  aspect-ratio: 480 / 133;
  display: flex;
  justify-content: center;
  align-items: center;
  .page-header-text {
    width: 20%;
  }
}
.movie-wrap {
  text-align: center;
  .movie-block-text {
    position: relative;
    width: 560px;
    margin: 10px auto;
    left: -16px;
    text-align: left;
    color: #5ba7f2;
    font-family: 'Hiragino';
  }
  .movie-block-iframe {
    border: 1px solid #5bdac5;
    padding: 7px;
    width : 560px;
    height : 315px;
  }
}

@media screen and (max-width: 1023px) {
  .page-header {
    background-image: url('@/assets/images/movie/sp_img_movie_01.png');
    aspect-ratio: 48 / 29;

    .page-header-text {
      width: 35%;
    }
  }
  .movie-wrap {
    .movie-block-text {
      width: 300px;
      left: -18px;
    }
    .movie-block-iframe {
      width : 300px;
      height : 180px;
    }
  }
}
</style>
